export type FormatOptions = {
    shorten?: boolean // Turn on/off shortening of large numbers (e.g., 1k, 1M, 1B)
    decimals?: number // Amount of decimals to show in the formatted number (e.g., 1.23k)
}

export function formatValue(
    value: number | undefined,
    options: FormatOptions = { shorten: false, decimals: 0 },
): string {
    if (value === undefined) {
        return ''
    }
    const { shorten, decimals } = options

    if (shorten) {
        const abs = Math.abs(value)
        const suffixes = [
            { threshold: 1e9, suffix: 'B' },
            { threshold: 1e6, suffix: 'M' },
            { threshold: 1e3, suffix: 'k' },
        ]

        for (const { threshold, suffix } of suffixes) {
            if (abs >= threshold) {
                return (value / threshold).toFixed(decimals) + suffix
            }
        }
    }
    return value.toString().replace(/(\d)(?=(\d{3})+$)/g, '$1 ')
}
